import type { TPost } from "@/utils/validators";
import { useMemo } from "react";

type UserAvatarProps = {
  post: TPost;
  width?: number;
  height?: number;
  includeName?: boolean;
};

export function UserAvatar({
  post,
  width = 20,
  height = 20,
  includeName = true,
}: UserAvatarProps) {
  const linkProps = post.user.profileUrl
    ? {
        href: post.user.profileUrl,
        target: "_blank",
        rel: "noopener noreferrer",
      }
    : {};

  return (
    <a
      {...linkProps}
      className="relative z-[2] mb-1 inline-flex items-center gap-2 hover:underline"
    >
      {post.user.profile_image && (
        <img
          src={post.user.profile_image}
          alt={post.user.name}
          className="rounded-full object-cover"
          style={{ width, height }}
        />
      )}
      {includeName && (
        <span className="text-sm font-semibold text-[#5f6a81]">
          {post.user.name}
        </span>
      )}
    </a>
  );
}
